import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around Connectors: /connectors.
 */
export default class ConnectorsClient extends CRUD {
	constructor() {
		super('/connectors');
	}
}
